const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/teams/team/$teamId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { FullSizeSpinner } from '@/common/components/ui/FullSizeSpinner';
import i18n from '@/common/translations/i18n';
import { compactBooleanFilterSchema, compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
import { getTeamQueryOptions } from '@/features/teams/queries/useGetTeamQuery';
export const teamSearchSchema = z.object({
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED', 'ALL']).optional(),
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  locationId: compactPicklistFilterSchema,
  employmentType: compactPicklistFilterSchema,
  showDeactivatedMembers: compactBooleanFilterSchema,
  showPastMemberships: compactBooleanFilterSchema,
  showFutureMemberships: compactBooleanFilterSchema
}) satisfies z.ZodType<{
  resourceStatus?: ResourceFilterStatus;
  roleId?: string;
  skillId?: string;
  locationId?: string;
  employmentType?: string;
  showDeactivatedMembers?: string;
  showPastMemberships?: string;
  showFutureMemberships?: string;
}>;
export const Route = createFileRoute('/(app)/org/$org/settings/teams/team/$teamId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(teamSearchSchema),
  loader: async ({
    params: {
      teamId
    },
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    if (!teamId) {
      return {
        crumb: i18n.t($ => $.team, {
          ns: 'teams'
        })
      };
    }
    try {
      const teamData = await queryClient.ensureQueryData(getTeamQueryOptions({
        teamId: Number(teamId)
      }));
      return {
        crumb: teamData?.team?.name || i18n.t($ => $.team, {
          ns: 'teams'
        })
      };
    } catch (_error) {
      return {
        crumb: i18n.t($ => $.team, {
          ns: 'teams'
        })
      };
    }
  },
  pendingComponent: FullSizeSpinner,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.teams)
    }
  }
});